import { render } from "./VideoModal.vue?vue&type=template&id=dc7cecd2&ts=true"
import script from "./VideoModal.vue?vue&type=script&lang=ts"
export * from "./VideoModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__